import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page';
import TopDetail from '../TopDetail';
import Page1 from './Page1';
import Page2 from './Page2';
import Page2Book from './Page2Book';
const L60_40 = ({ data, selectColor, tab }, ref) => {
  const [bookFormat, setBookFormat] = useState(false);
  // Güvenli erişim + filtre + kopya (referans tazele)
  const rawSizes = data?.washingLabel?.[selectColor]?.sizes || [];
  const allSizes = rawSizes
    .filter(item => (item?.amount ?? 0) > 0)
    .map(s => ({ ...s }));

  // 5'li gruplandır (yorumda 8 yazıyor ama kod 5; ihtiyacına göre değiştir)
  const filteredAndGroupedSizes = allSizes.reduce((acc, item, index) => {
    const groupIndex = Math.floor(index / 5);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(item);
    return acc;
  }, []);

  const makeBarcode = (sizeData) => {
    const [p0 = '', p1 = ''] = (data?.articleNo || '').split('/');
    const color = data?.washingLabel?.[selectColor]?.colorCode || '';
    const sCode = sizeData?.sCode || '';
    return `0${p0}${p1}${color}${sCode}`;
  };

  const stableKey = (sizeData, groupIndex, index) =>
    sizeData?.sCode || sizeData?.id || `${groupIndex}-${index}-${sizeData?.amount}`;
  useEffect(() => {
    const referenceCode = data?.referance?.code || '';
    if (referenceCode.includes("BOOK FORMAT") || referenceCode.includes("BOOK")) {
      setBookFormat(true);
    }
  }, [data?.referance?.code]);

  if (bookFormat) {
    return (
      <div className="flex flex-col items-center" ref={ref}>
        {allSizes.map((sizeData, index) => (
          <A4Page key={stableKey(sizeData, 0, index)} type="dikey">
            <div className="space-y-5">
              <TopDetail values={data} selectColor={selectColor} tab={tab} />
              <div className="space-y-3" style={{marginTop:4}}
              >
      
                <Page2Book data={data} sizeData={sizeData} selectColor={selectColor} barcodeValue={makeBarcode(sizeData)} />
              </div>
            </div>
          </A4Page>
        ))}
      </div>
    );
  }
  
  return (
    <div className="flex flex-col items-center" ref={ref}>
      {filteredAndGroupedSizes.map((group, groupIndex) => (
        <A4Page key={`page-${groupIndex}`} type="dikey">
          <div className="space-y-5">
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
            <div className="space-y-3">
              {group.map((sizeData, index) =>
                sizeData ? (
                  <Page1
                    key={stableKey(sizeData, groupIndex, index)}
                    selectColor={selectColor}
                    barcodeValue={makeBarcode(sizeData)}
                    data={data}
                    sizeData={sizeData}
                  />
                ) : null
              )}
            </div>
          </div>
        </A4Page>
      ))}

      {/* En sondaki ikinci sayfa – KALDI */}
      <A4Page type="dikey">
        <div className="space-y-5">
          <TopDetail values={data} selectColor={selectColor} tab={tab} />
          <Page2 data={data} />
        </div>
      </A4Page>
    </div>
  );
};

export default React.forwardRef(L60_40);
